import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../fb";

// Support-Tickets (support/{orderId}). Quelle der Wahrheit ist Quelp: der
// Webhook-Spiegel (functions/rateTaskApp/quelp.js) schreibt quelpTickets,
// pending/waiting und Bestell-Kopfdaten. Legacy-Tickets der Status-Seite
// (data.*) bleiben lesbar.
//   pending && !waiting → offen (Kunde wartet auf uns)
//   pending && waiting  → beantwortet, Bestellung noch on hold
//   !pending            → erledigt
const defaultState = {
  ticketsActiveMap: {},
  ticketsClosed: [],
  loadingTickets: false,
  unsubActive: null,
  unsubClosed: null,
};

const sortByCreated = (a, b) =>
  String(b.quelpLastMessageAt || b.created || "").localeCompare(
    String(a.quelpLastMessageAt || a.created || "")
  );

const getters = {
  ticketsActive: (state) =>
    Object.values(state.ticketsActiveMap).sort(sortByCreated),
  ticketsOpen: (state, g) => g.ticketsActive.filter((t) => !t.waiting),
  ticketsWaiting: (state, g) => g.ticketsActive.filter((t) => !!t.waiting),
  ticketsQuelp: (state, g) => g.ticketsActive.filter((t) => !!t.quelpId),
  ticketsClosed: (state) => state.ticketsClosed,
  orderIdsInSupport: (state) => Object.keys(state.ticketsActiveMap),
  loadingTickets: (state) => state.loadingTickets,
  unsubTickets: (state) => ({ OPEN: state.unsubActive, CLOSED: state.unsubClosed }),
  ticketByOrder: (state) => (orderUid) =>
    state.ticketsActiveMap[String(orderUid)] || null,
};

const actions = {
  // Idempotent: ein Live-Listener für alle aktiven Tickets, einer für die
  // letzten erledigten. `type` bleibt aus Kompatibilität (OPEN/WAITING/QUELP/CLOSED).
  async loadTickets({ commit, state }, type) {
    const supportCollection = collection(db, "support");
    if (type === "CLOSED") {
      if (state.unsubClosed) return;
      const q = query(
        supportCollection,
        where("pending", "==", false),
        orderBy("created", "desc"),
        limit(60)
      );
      const unsub = onSnapshot(q, (snapshot) => {
        commit(
          "setClosedTickets",
          snapshot.docs.map((d) => ({ ...d.data(), orderUid: d.data().orderUid || d.id }))
        );
      });
      commit("setUnsubClosed", unsub);
      return;
    }
    if (state.unsubActive) return;
    commit("setLoadingTickets", true);
    const q = query(
      supportCollection,
      where("pending", "==", true),
      orderBy("created", "desc"),
      limit(400)
    );
    const unsub = onSnapshot(
      q,
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data();
          const ticket = { ...data, orderUid: data.orderUid || change.doc.id };
          if (change.type === "removed") commit("removeActiveTicket", ticket);
          else commit("setActiveTicket", ticket);
        });
        commit("setLoadingTickets", false);
      },
      (err) => {
        console.error("Support-Listener fehlgeschlagen:", err);
        commit("setLoadingTickets", false);
      }
    );
    commit("setUnsubActive", unsub);
  },
  unsubTickets({ state, commit }) {
    if (typeof state.unsubActive === "function") state.unsubActive();
    if (typeof state.unsubClosed === "function") state.unsubClosed();
    commit("setUnsubActive", null);
    commit("setUnsubClosed", null);
  },
};

const mutations = {
  setLoadingTickets: (state, bool) => (state.loadingTickets = bool),
  setActiveTicket(state, ticket) {
    state.ticketsActiveMap = {
      ...state.ticketsActiveMap,
      [String(ticket.orderUid)]: ticket,
    };
  },
  removeActiveTicket(state, ticket) {
    const next = { ...state.ticketsActiveMap };
    delete next[String(ticket.orderUid)];
    state.ticketsActiveMap = next;
  },
  setClosedTickets: (state, tickets) => (state.ticketsClosed = tickets),
  setUnsubActive: (state, fn) => (state.unsubActive = fn),
  setUnsubClosed: (state, fn) => (state.unsubClosed = fn),
};

export default {
  state: { ...defaultState },
  getters,
  actions,
  mutations,
};
